shadow$provide[1] = function(require,module,exports) {
module.exports=(ReactDOM);
};